import { Component, EventEmitter, HostListener, OnInit, ViewChild } from '@angular/core';
import { KontableComponent } from 'app/modules/UIKit/components/kontable/kontable.component';
import { Campaign2Service } from 'app/services/campaign-2.0/campaign2.service';
import { Campaign3Service } from '../../campaign-3/services/campaign3.service';
import { Campaign3BreadcrumbComponent } from '../../campaign-3/components/campaign-3-breadcrumb/campaign-3-breadcrumb.component';
import { BreadCrumbModel } from '../../campaign-3/models/campaign-3-breadcrumb.model';
import { ActivatedRoute, Router } from '@angular/router';
import { Campaign3TestService } from '../../campaign-3/services/campaign3testservice';
import { Observable } from 'rxjs';
import { Campaign3KontableComponent } from '../../campaign-3/components/campaign-3-kontable/campaign-3-kontable.component';
import { Campaign3Campaign, DistributionCluster3, DistributionList3 } from '../../campaign-3/models/campaign-3.model';
import { CalendarTranslateService } from 'app/modules/UIKit/services/calendarTranslate.service';
import { ActionStateService } from '../../campaign-3/services/actionstate.service';
import { MessageService } from 'primeng/primeng';
import { TranslateService } from '@ngx-translate/core';
import { DistributionList3Service } from '../services/distribution3.service';





@Component({
    selector: 'app-distribution-list-3',
    templateUrl: './distribution-list-3.component.html',
    styleUrls: ['./distribution-list-3.component.css']
})
export class DistributionList3Component implements OnInit {
    @ViewChild('breadcrumbComponent') breadcrumb: Campaign3BreadcrumbComponent;
    @ViewChild('distributionlist') kontableComponent: Campaign3KontableComponent;

    breadcrumbs: Array<BreadCrumbModel> = [];
    paginationType = KontableComponent.ServerPagination;
    dateFilter = KontableComponent.DateFilter;
    numberFilter = KontableComponent.NumberFilter;
    textFilter = KontableComponent.TextFilter;
    selectFilter = KontableComponent.SelectFilter;
    noFilter = KontableComponent.NoFilter;

    pageSubject = "distribution-list";
    showPopupEdit = false;
    showPopupCreate = false;
    readyTable = false;

    startDate;
    endDate;

    showMenu = false;
    currentOpenedRow;

    campaignActionList = [];
    newCampaign = false;
    allActionList;

    selectedCampaignActions: any;
    distributionListToDelete: any;
    displayDeleteDialog = false;

    campaignType: Array<{ label: string, value: string }>;
    statusList: Array<{ label: string, value: string }>;
    budgetList: Array<{ label: string, value: string }>;

    campaignActions;
    singleCampaign: Campaign3Campaign;
    singleCampaignStartDate: Date;
    singleCampaignEndDate: Date;

    fieldModel = {
        campaign_name: "campaign_name",
        campaign_description: "campaign_description",
        start_date: "start_date",
        end_date: "end_date",
        budget_type: "budget_type",
        budget_value: "budget_value",
        campaign_type: "campaign_type"
    };

    constructor(
        public campaign2Service: Campaign2Service,
        public campaign3Service: Campaign3Service,
        public testService: Campaign3TestService,
        public router: Router,
        private activatedRoute: ActivatedRoute,
        public srvCalendar: CalendarTranslateService,
        public actionStateService: ActionStateService,
        private srvNotify: MessageService,
        private translate: TranslateService,
        private distributionService: DistributionList3Service,
        private translateService: TranslateService,
    ) { }

    ngOnInit(): void {
        this.readyTable = true;
        this.initBreadCrumbs();
    }

    breadcrumbClicked(breadcrumb: BreadCrumbModel) {
        if (breadcrumb.routerLink) {
            this.router.navigate([breadcrumb.routerLink]);
        } else {
            console.log("Nessuna route implementata");
        }
    }

 /*    initBreadCrumbs() {
        this.breadcrumbs.push({
            code: "bc1",
            description: "Liste di Distribuzione",
            routerLink: "/distribution-list-3"
        });
    } */
    showBreadCrumb:boolean= false;
    private initBreadCrumbs() {
   
        let breadCrumbDistribution;
   
        this.translateService.get([
          'breadCrumb.distributionList', 
        ]).subscribe(translations => {
          breadCrumbDistribution = translations['breadCrumb.distributionList'];
          this.breadcrumbs = [
            { code: 'bc1', description: breadCrumbDistribution, routerLink: '/distribution-list-3' },
          
          ];
          this.showBreadCrumb= true;
        });
      }

    onOpenEdit(row: DistributionList3): void {
        this.distributionService.setData(row);
        this.router.navigate(['/edit-create-distribution-list-3']);
    }

    onOpenCreation() {
        this.distributionService.resetData();
        this.router.navigate(['/edit-create-distribution-list-3']);
    }

    onActionTable() {
        this.router.navigate(["/action-list-3"]);
    }

    onClosePopupEdit() {
        this.showPopupEdit = false;
    }

    onClosePopupCreation() {
        this.showPopupCreate = false;
    }

    clearDateFields() {
        this.startDate = null;
        this.endDate = null;
    }

    refreshAfterEdit() {
        this.kontableComponent.refresh();
    }

    onCheckEndDistribution(row) {
        return row.end_date && new Date(row.end_date) < new Date() || row.flg_state === "1";
    }

    checkAlreadyDeleted(row) {
        return row.flg_state === "1";
    }

   

    toggleMenu(row: DistributionList3) {
        let id = row.distributionListId;
        if (this.showMenu && this.currentOpenedRow !== id) {
            this.showMenu = false;
        }
        this.currentOpenedRow = id;
        this.showMenu = !this.showMenu;
    }

    @HostListener('document:click', ['$event'])
    onClick(event: any) {
        if (!event.target.closest('.dropdown-menu') && !event.target.closest('.d-flex')) {
            this.showMenu = false;
        }
    }

    deleteDistributionList(row: any) {
        this.distributionListToDelete = row;
        console.log("Procedere con i controlli, popup e infine definitiva eliminazione");
        this.displayDeleteDialog = true;
    }

    closePopupDelete() {
        this.displayDeleteDialog = false;
    }

    onDefinitiveDelete(row: DistributionList3) {
        this.distributionService.deleteDistributionList(row.distributionListId).subscribe({
            next: () => {
                this.displayDeleteDialog = false;
                this.srvNotify.add({
                    severity: 'success',
                    summary: this.translate.instant('common.success'),
                    detail: this.translate.instant('distributionList.distribution_delete_success'),
                    life: 5000,
                });
                this.kontableComponent.refresh();
            },
            error: (err) => {
                console.error('Errore durante la cancellazione:', err);
                this.srvNotify.add({
                    severity: 'error',
                    summary: this.translate.instant('common.error'),
                    detail: this.translate.instant('distributionList.distribution_delete_error'),
                    life: 5000,
                });
            },
        });
    }

    refreshClusterViaKontable(row: DistributionList3) {
        this.kontableComponent.refreshClusterList(row.distributionListId);
        this.kontableComponent.refresh();
    }


    onViewPromoList(row: DistributionList3) {
        this.router.navigate(['/promo-list-detail-3'], {
            queryParams: { idRow: row.distributionListId }
        });
    }
}




// WEBPACK FOOTER //
// ./src/app/views/distribution-list/distribution-list-3/distribution-list-3.component.ts